import { render, staticRenderFns } from "./LiveChatAction.vue?vue&type=template&id=3dffb5a5&scoped=true&"
import script from "./LiveChatAction.vue?vue&type=script&lang=js&"
export * from "./LiveChatAction.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatAction.vue?vue&type=style&index=0&id=3dffb5a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dffb5a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSwitch,VTextField})
